import { FlexBox } from '@dixa/lib-shared-habla';
import { Field } from 'redux-form';

import { MessengerTranslatedLanguage } from 'components/settings/components/sections/dixaMessenger/views/appearance/components/generalSettings/languageSettings/languages';
import { messengerSettingsFormFields } from 'components/settings/components/sections/dixaMessenger/views/appearance/types';
import { CharLimitFieldText } from 'components/shared/charLimitFieldText';

const MAX_LENGTH = 85;
const BUTTON_LABEL_MAX_LENGTH = 35;

interface TitleDescriptionEditorProps {
  currentLangCode: MessengerTranslatedLanguage;
}

export function DynamicStringsEditor({
  currentLangCode,
}: TitleDescriptionEditorProps): JSX.Element {
  return (
    <FlexBox flexDirection="column" flex="1" gap="400">
      <Field
        label="Title"
        name={`${messengerSettingsFormFields.title}[${currentLangCode}]`}
        component={CharLimitFieldText}
        inputType="text"
        maxLength={MAX_LENGTH}
        helpIcon={{ text: 'Leave empty to use the default title' }}
        placeholder="Custom title"
      />
      <Field
        label="Description"
        placeholder="Custom description"
        name={`${messengerSettingsFormFields.description}[${currentLangCode}]`}
        component={CharLimitFieldText}
        inputType="textarea"
        props={{ style: { maxHeight: '90px' } }}
        maxLength={MAX_LENGTH}
        helpIcon={{ text: 'Leave empty to use the default message' }}
      />
      <Field
        label="Start a Conversation"
        placeholder="Custom start conversation button label"
        name={`${messengerSettingsFormFields.startConversation}[${currentLangCode}]`}
        component={CharLimitFieldText}
        inputType="text"
        maxLength={BUTTON_LABEL_MAX_LENGTH}
        helpIcon={{ text: 'Leave empty to use the default message' }}
      />
    </FlexBox>
  );
}
